<template>
  <el-container>
    <Aside
      class="transition-box"
      height="100%"
      @toHideTags="handleTags"
    >
      <template #arrow>
        <div
          v-if="!isCollapseAside"
          class="collapse-button"
          @click="toggleCollapse"
        >
          <i class="el-icon-arrow-left"/>
        </div>
      </template>
    </Aside>

    <el-container class="main-part">
      <Header v-if="showHeader"/>
      <el-container class="body-container">
        <tags-view v-show="visitedViews?.length"/>
        <router-view :key="key" class="view-container"/>
        <div
          v-if="isCollapseAside"
          class="open-button collapse-button"
          @click="toggleCollapse"
        >
          <i class="el-icon-arrow-right"/>
        </div>
        <el-footer>
          <Footer/>
        </el-footer>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
import "@/assets/css/base.css";
import Header from "@components/headers";
import Footer from "@/components/footers/Footer";
import Aside from "@components/asides";
import TagsView from "@/components/TagsView";
import { mapState } from "vuex";

export default {
  name: "Home",
  components: {
    Header,
    Footer,
    Aside,
    TagsView
  },
  data() {
    return {
      showHeader: true, // 展示header
      isShowTags: true,
    };
  },
  computed: {
    key() {
      return this.$route.name !== undefined
        ? this.$route.name + new Date()
        : this.$route + new Date();
    },
    ...mapState({
      visitedViews: "visitedViews",
      isCollapseAside: "isCollapseAside"
    }),
  },
  methods: {
    handleTags(isHide) {
      this.isShowTags = !isHide;
    },
    toggleCollapse() {
      this.$store.commit("updateCollapseAside", !this.isCollapseAside);
    },
  },
};
</script>
<style scoped lang="scss">
.el-container {

  background-color: #f0f5f7;
}

.el-container.main-part {
  overflow: auto;
  flex-direction: column;
}

.view-container {
  flex: 1;
}

.el-main {
  padding: 0;
  position: relative;
  overflow: auto;
}

.el-footer {
  height: 40px !important;
  font-size: 14px;
  font-weight: 400;
  color: #999999;
}

.collapse-button {
  cursor: pointer;
  right: 22px;
  top: 97%;
  transform: translateY(-50%);
  position: absolute;
  color: white;
}

.open-button {
  left: 30px;

}

.body-container {
  padding-right: 24px;
}
</style>
